import * as yup from 'yup';

export const offerValidationSchema = yup.object({
  offer_name: yup
    .string()
    .required('Offer name is required')
    .min(3, 'Offer name must be at least 3 characters')
    .max(100, 'Offer name must not exceed 100 characters'),

  scope: yup.array().of(yup.number()).min(1, 'At least one platform must be selected'),

  price: yup
    .number()
    .nullable()
    .required('Price is required')
    .min(0, 'Price must be greater than or equal to 0')
    .max(999999, 'Price must not exceed 999,999'),

  currency: yup.number().required('Currency is required'),

  offer_category: yup.number().required('Offer category is required'),

  duration: yup.number().typeError('Duration must be a number'),
  // .test(
  //   'valid-duration',
  //   'Duration must be 0 or between 1 and 365 days (in seconds)',
  //   (value) => value === 0 || (value >= 86400 && value <= 31536000)
  // ),

  premium_ids: yup.array().of(yup.string().trim().required()).min(1, 'At least one premium ID is required'),

  start_date: yup.string(),
  // .required('Start date is required')
  // .test('is-future-date', 'Start date must be in the future', function (value) {
  //   if (!value) return true;
  //   const startDate = new Date(value);
  //   const today = new Date();
  //   today.setHours(0, 0, 0, 0);
  //   return startDate >= today;
  // })
  end_date: yup
    .string()
    // .required('End date is required')
    .test('is-after-start', 'End date must be after start date', function (value) {
      const { start_date } = this.parent;
      if (!value || !start_date) return true;
      return new Date(value) > new Date(start_date);
    }),

  quantity: yup
    .number()
    .nullable()
    // .required('Quantity is required')
    .min(0, 'Quantity must be at least 0')
    .max(1000000, 'Quantity must not exceed 1,000,000'),

  country: yup.array().of(yup.number()),
  // .min(1, 'At least one country must be selected'),

  comment: yup.string().max(500, 'Comment must not exceed 500 characters'),

  custom_name: yup.object().default({}),

  trigger_login_reward: yup.object().default({}),

  starter_offer: yup.boolean().default(false),

  min_user_age: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .min(0, 'Minimum user age must be 0 or greater')
    .max(120, 'Minimum user age must not exceed 120')
    .default(null),

  max_user_age: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .min(0, 'Maximum user age must be 0 or greater')
    .max(120, 'Maximum user age must not exceed 120')
    .test('is-greater-than-min', 'Maximum age must be greater than minimum age', function (value) {
      const { min_user_age } = this.parent;
      if (value == null || min_user_age == null) return true;
      return value >= min_user_age;
    })
    .default(null),

  min_ltv: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .min(0, 'Minimum LTV must be 0 or greater')
    .default(null),

  max_ltv: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .min(0, 'Maximum LTV must be 0 or greater')
    .test('is-greater-than-min-ltv', 'Maximum LTV must be greater than minimum LTV', function (value) {
      const { min_ltv } = this.parent;
      if (value == null || min_ltv == null) return true;
      return value >= min_ltv;
    })
    .default(null),

  desktop_background: yup
    .string()
    .test('url-or-filename', 'Desktop background must be a valid URL or filename', (value) => {
      if (!value) return true;
      const isUrl = /^https?:\/\//i.test(value);
      const isFilename = /[^\s]+\.[^\s]+$/.test(value);
      return isUrl || isFilename;
    }),

  mobile_background: yup
    .string()
    .test('url-or-filename', 'Mobile background must be a valid URL or filename', (value) => {
      if (!value) return true;
      const isUrl = /^https?:\/\//i.test(value);
      const isFilename = /[^\s]+\.[^\s]+$/.test(value);
      return isUrl || isFilename;
    }),

  mobile_icon: yup.string().test('url-or-filename', 'Mobile icon must be a valid URL or filename', (value) => {
    if (!value) return true;
    const isUrl = /^https?:\/\//i.test(value);
    const isFilename = /[^\s]+\.[^\s]+$/.test(value);
    return isUrl || isFilename;
  }),

  popup_background: yup
    .string()
    .test('url-or-filename', 'Popup background must be a valid URL or filename', (value) => {
      if (!value) return true;
      const isUrl = /^https?:\/\//i.test(value);
      const isFilename = /[^\s]+\.[^\s]+$/.test(value);
      return isUrl || isFilename;
    }),

  popup_icon: yup.string().test('url-or-filename', 'Popup icon must be a valid URL or filename', (value) => {
    if (!value) return true;
    const isUrl = /^https?:\/\//i.test(value);
    const isFilename = /[^\s]+\.[^\s]+$/.test(value);
    return isUrl || isFilename;
  }),

  is_featured: yup.boolean().default(false),
  is_test_offer: yup.boolean().default(false),

  user_id: yup
    .string()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .default(null),

  is_shop_default: yup.boolean().default(false),

  // Optional item fields
  hero_item_id: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .default(null),
  level_item_id: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .default(null),
  medal_item_id: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .default(null),
  required_medals: yup
    .number()
    .nullable()
    .transform((value, originalValue) => (originalValue === '' || originalValue === null ? null : value))
    .default(null),

  sync_on: yup.string(),
});

export type OfferFormValues = yup.InferType<typeof offerValidationSchema>;
